import React                from "react";
import Store                from "Dashboard/Core/Store";
import Action               from "Dashboard/Core/Action";
import useList              from "Dashboard/Hooks/List";

// Components
import EmailTemplateView    from "./EmailTemplateView";

// Dashboard
import Main                 from "Dashboard/Components/Core/Main";
import Content              from "Dashboard/Components/Core/Content";
import Header               from "Dashboard/Components/Header/Header";
import Table                from "Dashboard/Components/Table/Table";
import TableHead            from "Dashboard/Components/Table/TableHead";
import TableBody            from "Dashboard/Components/Table/TableBody";
import TableRow             from "Dashboard/Components/Table/TableRow";
import TableHeader          from "Dashboard/Components/Table/TableHeader";
import TableCell            from "Dashboard/Components/Table/TableCell";
import TablePaging          from "Dashboard/Components/Table/TablePaging";
import TableActionList      from "Dashboard/Components/Table/TableActionList";
import TableAction          from "Dashboard/Components/Table/TableAction";



/**
 * The Email Template List
 * @returns {React.ReactElement}
 */
function EmailTemplateList() {
    const { load } = useList("emailTemplate");

    const data = Store.useState("emailTemplate");
    const { loading, canEdit, list, total, sort } = data;

    // The Current State
    const [ action, elemID, startAction, endAction ] = Action.useActionID();


    // Do the Render
    return <Main>
        <Header message="EMAIL_TEMPLATES_NAME" icon="email" />
        <Content>
            <Table
                fetch={load}
                sort={sort}
                none="EMAIL_TEMPLATES_NONE_AVAILABLE"
                isLoading={loading}
            >
                <TableHead>
                    <TableHeader field="description" message="GENERAL_DESCRIPTION" isTitle />
                    <TableHeader field="subject"     message="GENERAL_SUBJECT"     grow="1.5" />
                    <TableHeader field="position"    message="GENERAL_POSITION"    maxWidth="80" align="center" hideMobile />
                </TableHead>
                <TableBody>
                    {list.map((elem) => <TableRow key={elem.templateID} elemID={elem.templateID}>
                        <TableCell message={elem.description} />
                        <TableCell message={elem.subject}     />
                        <TableCell message={elem.position}    />
                    </TableRow>)}
                </TableBody>
                <TablePaging total={total} />
                <TableActionList onAction={startAction} canEdit={canEdit}>
                    <TableAction action="VIEW" message="EMAIL_TEMPLATES_VIEW_TITLE" />
                </TableActionList>
            </Table>
        </Content>

        <EmailTemplateView
            open={action.isView}
            elemID={elemID}
            onClose={endAction}
        />
    </Main>;
}

export default EmailTemplateList;
